export default function Error() {
    return(
        <div className="error-container">
            <h1 className="text-primary">404</h1>
            <p>The request page is not available</p>
        </div>
    )
}